import Vue from "vue";
import { aesEncrypt } from '@utils/index.js';

export const gameAdv = {
   async show(advData,timePeriod,callback,obj){
        Vue.prototype.$loading.show()
        Vue.prototype.WebApp.BackButton.hide()
        try{
            switch(advData.platform){
                case 'adsgram':
                    const AdController = await window.Adsgram.init({ blockId: advData.url.toString() });
                    await AdController.show().then(async (result) => {
                        // user watch ad till the end
                        // your code to reward user
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback)
                    }).catch((result) => {
                        // user skipped video or get error during playing ad
                        // do nothing or whatever you want
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    })
                    break;
                case "openad":
                    const adParams = {
                        TG: {
                            type: 'TMA', // TMA, WEB, WEB3,
                            isFullscreen: false, // true: If your TMA is in fullscreen mode
                        },
                        wallet: { // If you have a web3 wallet components, Optional
                            type: '', // eth: eth wallet, kaia: line wallet, ton: ton wallet;
                            provider: null, // here is a provider object after wallet initialization.
                            components: '', // web3 wallet components name
                        },
                    };
                    let dataParams =  advData.url.split("|")
                    const adInfo = {
                        zoneId     : Number(dataParams[0]), // example zoneId, please check your own code parameters
                        publisherId: Number(dataParams[1]), // example publisherId, please check your own code parameters
                        //eventId    : 0,  // Reserved Parameter
                    };
                    let res = await window.OpenADTGJsSDK.interactive.init({ adParams, adInfo });
                    Vue.prototype.$loading.hide()
                    if(res && res.code === 0){
                        const callbackFunc = {
                            // Indicates load ad resource from OpenAD platform, false will be returned if there is no resource to be loaded for the publisher slot/zone
                            onAdResourceLoad: (e) => {
                            // 'step1', e = ture / false
                            },
                            // Indicates the interactive ad is opening
                            onAdOpening: (e) => {
                            // 'step2', e = ture / false
                            },
                            // Indicates the interactive ad is opened,
                            onAdOpened: (e) => {
                            // 'step3',  e = ture / false
                            },
                            // indicates the interactive ad task is finished, the task is defined by publisher
                            onAdTaskFinished:async (e) => {
                                // 'step5',  e = viewAD / click  / close
                                Vue.prototype.$loading.hide()
                                Vue.prototype.WebApp.BackButton.show()
                                await this.complete(advData,timePeriod,callback);
                            },
                            // Indicates the interactive ad is closing
                            onAdClosing: (e) => {
                            // 'step6', e = viewAD / click  / close
                            },
                            // Indicates the interactive ad is closed
                            onAdClosed: (e) => {
                            // 'step7', e = viewAD / click / close
                            // If you want to perform different steps based on different shutdown states, please write the code here.
                            },
                            // Indicates clicked and jumps
                            onAdClick: (e) => {
                            // 'step4', e = ture / false
                            },
                        };

                        // Call SDK method to get advertising and render data
                        window.OpenADTGJsSDK.interactive.getRender({ adInfo, cb: callbackFunc })
                        
                    }
                    else{
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    }
                    break;
                case "tonai":
                    let params = { appId: '676a5db777f388016248ad84', debug: false };
                    window.TonAISdk.TonAdInit(params)

                    const blockId = advData.url
                    const limit = 5
                    window.TonAISdk.GetMultiTonAd(blockId, limit)
                    .then((res) => {
                        Vue.prototype.$loading.hide()
                        let ads = res.ads;
                        if (ads && ads.length > 0) {
                        let idx = Math.floor(Math.random() * (ads.length - 1));
                        // 广告加载成功，可以在适当的时机展示
                        window.TonAISdk.TonAdPopupShow({
                            tonAd: ads[idx], // 用户点击的广告对象
                            countdown: 15,  // 可以不设置，默认值为 10 秒，最小值为 10 秒，最大值为 30 秒
                            autoClose: true, // 默认值为 true，表示广告倒计时结束后自动关闭广告
                            onAdComplete: async(ad) => {
                                // 用户看完了广告, 可以在此发放奖励
                                // sendReward(ad)
                                Vue.prototype.WebApp.BackButton.show()
                                await this.complete(advData,timePeriod,callback);
                            },
                            onAdClick:async (ad) => {
                                // 用户点击了广告, 可以在此发放奖励
                                // sendReward(ad)
                                Vue.prototype.WebApp.BackButton.show()
                                await this.complete(advData,timePeriod,callback);
                            },
                            onAdError: (error) => {
                                // 用户在播放广告时遇到错误
                                console.error(error)
                                Vue.prototype.WebApp.BackButton.show()
                                obj.isClickAdv = false
                            },
                            onAdClose: (ad) => {
                                // 用户手动关闭了广告
                                Vue.prototype.WebApp.BackButton.show()
                                obj.isClickAdv = false
                            }
                        })
                    } else {
                            // 没有可用的广告
                            Vue.prototype.WebApp.BackButton.show()
                            obj.isClickAdv = false
                    }
                    })
                    .catch((error) => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        console.error('加载广告失败:', error)
                    })
                    break;
                case "tmads":
                    TMAds.init({
                        app_key:advData.url,
                        init_data:Vue.prototype.WebApp.initData,
                        init_data_unsafe:Vue.prototype.WebApp.initDataUnsafe
                    });
                    TMAds.showInterstitialAd()
                    .then(async ()=>{
                        //interstitial ad has been successfully shown and closed
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback);
                    })
                    .catch(()=>{
                        //interstitial ad failed to show (likely due to the network issues)
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    });
                    break;
                case "monetag":
                    show_9578105().then( async () => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback);
                    })
                    .catch(()=>{
                        //interstitial ad failed to show (likely due to the network issues)
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    });
                    break;
                case "adexium":
                    const adexiumAds = new AdexiumWidget({
                        wid: '7b1d0dfe-5285-46ab-a661-0cfc9061b049', 
                        adFormat: 'interstitial',
                        isFullScreen:true
                    });

                    adexiumAds.requestAd('interstitial');

                    adexiumAds.on('adReceived', (ad) => {
                        adexiumAds.displayAd(ad); // displaying ad
                        console.log('ad received')
                    });

                    const noAdFoundListener = () => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    };

                    adexiumAds.on('noAdFound', noAdFoundListener);

                    adexiumAds.on('adClosed', () => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                        console.log('ad closed')
                    });

                    adexiumAds.on('adPlaybackCompleted',async () => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()      
                        await this.complete(advData,timePeriod,callback);
                    })
                    break;
                case "tads":
                    const WIDGET_ID = "625";

                    // Use 'true' for development and 'false' for production
                    const IS_DEBUG = false;
                    
                    // Callback for REWARDED format.
                    const onShowRewardCallback =async (result) => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()      
                        await this.complete(advData,timePeriod,callback);
                    };

                    // Callback for no ads response
                    const onAdsNotFound = () => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    }

                    const onClickReward = async () =>{
                        console.log('ok')
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback);
                    }
                    const adController = await window.tads.init({
                        widgetId: WIDGET_ID,
                        type: 'fullscreen',
                        debug: IS_DEBUG,
                        onShowReward: onShowRewardCallback,
                        onAdsNotFound: onAdsNotFound,
                        onClickReward: onClickReward
                    });
                    adController.loadAd()
                    .then((res) =>{adController.showAd()})
                    .catch((result) => {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    });
                    break;
                case "onclicka":
                    window.initCdTma?.({ id: 6085391})
                    .then(show => {
                        window.show = show
                        if(!show){
                            Vue.prototype.$loading.hide()
                            Vue.prototype.WebApp.BackButton.show()
                            obj.isClickAdv = false
                            console.log("no ad")
                            return;
                        }
                        window.show?.().then(
                            async() => {
                                console.log('Onclicka ad played')
                                Vue.prototype.$loading.hide()
                                Vue.prototype.WebApp.BackButton.show()
                                await this.complete(advData,timePeriod,callback);
                            }).catch(e => {
                                console.log(e)
                                Vue.prototype.$loading.hide()
                                Vue.prototype.WebApp.BackButton.show()
                                obj.isClickAdv = false
                            })
                    })
                    .catch(e => {console.log(e);
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    })
                    break;
                case "richads":
                    const originalAddEventListener = EventTarget.prototype.addEventListener;
                    let listener = []
                    try{
                        EventTarget.prototype.addEventListener = function(type, handler, options) {
                            if(this === document && type === 'click'){
                                listener.push(handler)
                            }
                            return originalAddEventListener.call(this, type, handler, options);
                        };

                        window.TAdsController = new TelegramAdsController();
                        await window.TAdsController.initialize({
                            pubId: "982447",
                            appId: "3124",
                            debug: false
                        });
                        
                        window.TAdsController.triggerInterstitialBanner(false).then(async (result) => {
                            if(listener){
                                listener.forEach((item)=>{
                                    document.removeEventListener("click",item)
                                })
                                listener = []
                            }
                            Vue.prototype.$loading.hide()
                            Vue.prototype.WebApp.BackButton.show()
                            await this.complete(advData,timePeriod,callback);
                        }).catch((result) => {
                            if(listener){
                                listener.forEach((item)=>{
                                    document.removeEventListener("click",item)
                                })
                                listener = []
                            }
                            Vue.prototype.$loading.hide()
                            Vue.prototype.WebApp.BackButton.show()
                            obj.isClickAdv = false
                        })
                    }
                    catch(e)
                    {
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    }
                    finally{
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                        EventTarget.prototype.addEventListener = function(type, handler, options) {
                            return originalAddEventListener.call(this, type, handler, options);
                        };
                    }
                    break;
                case "adextra":
                    const onError = (e) => {
                        console.log(e)
                        console.log('error')
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    }

                    const onSuccess = async () => {
                        console.log('success')
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback);
                    }
                    p_adextra(onSuccess, onError)
                    break;
                case "giga":
                    window.showGiga()
                    .then(async () => {
                        // Your reward logic here
                        console.log('success')
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        await this.complete(advData,timePeriod,callback);
                    })
                    .catch(e => {
                        // Handle errors here
                        Vue.prototype.$loading.hide()
                        Vue.prototype.WebApp.BackButton.show()
                        obj.isClickAdv = false
                    });
                    break;
            }
        }
        catch(e){
            Vue.prototype.$loading.hide()
            Vue.prototype.WebApp.BackButton.show()
            obj.isClickAdv = false
        }
    },
    async complete(advData,timePeriod,callback){
        try{
            let advDataStr = aesEncrypt(JSON.stringify({id:advData.id,game_type:advData.game_type,time_period:timePeriod, time:new Date().getTime()}))
            let res = await Vue.prototype.$http.post("/game/adv/complete",{"advData":advDataStr,'_n':1});
            if(callback){
                callback(res)
            }
        }
        catch(e){
            callback(null)
        }
    }
}